<template>
	<div>
		<div
			class="tabs"
			:style="`background-color:${globalColors.border}`"
		>
			<button 
				v-for="item in data" 
				:key="item.id"
				class="tabs-item"
				:style="`border-bottom: 0.6rem solid ${item.active ? globalColors.primary : globalColors.border};`"
				@click="$emit('select', item)"
			>{{item.name}}</button>
		</div>
		<div>
			<slot></slot>
		</div>
	</div>
</template>
<script>

export default {
	name: 'tabs',
	props: {
		data: {
			type: [Array, Object],
			default: () => [],
		},
	},
};
</script>
<style lang="scss" scoped>

	.tabs{
		display: flex;
		font-family: font(open-semibold);
		justify-content: space-around;
		margin-bottom: 4.5rem;
	}

	.tabs-item {
		background: none;
		border: none;
		color: color(backTab);
		cursor: pointer;
		font-family: font(open-semibold);
		font-size: size(medium);
		outline: none;
		padding: 1.5rem 1.4rem;
		text-transform: uppercase;
	}

	@media screen and (max-width: 1024px) {
		.tabs {
			flex-direction: column;
		}
	}
</style>





// WEBPACK FOOTER //
// tabsProduct.vue?b346997c